var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V72H0z",
    transform: "translate(-969 -452) translate(892 398) translate(32 54) translate(45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B78A22",
    d: "M10.8 20.667c3.976 0 7.2-3.284 7.2-7.334S14.776 6 10.8 6s-7.2 3.283-7.2 7.333c.004 4.049 3.225 7.33 7.2 7.334zm54 3.666h-7.2c-1.902-.002-3.726.765-5.074 2.132 4.622 2.562 7.763 7.22 8.449 12.535H68.4c1.988 0 3.6-1.642 3.6-3.667v-3.666c-.004-4.049-3.225-7.33-7.2-7.334zm-57.6 0c-3.975.004-7.196 3.285-7.2 7.334v3.666C0 37.358 1.612 39 3.6 39h7.414c.695-5.314 3.838-9.97 8.46-12.535-1.348-1.367-3.172-2.134-5.074-2.132H7.2zm54-3.666c3.976 0 7.2-3.284 7.2-7.334S65.176 6 61.2 6 54 9.283 54 13.333c.004 4.049 3.225 7.33 7.2 7.334z",
    transform: "translate(-969 -452) translate(892 398) translate(32 54) translate(45) translate(0 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF72",
    d: "M44.4 29.143h-.908c-2.333 1.187-4.895 1.81-7.492 1.821-2.69 0-5.206-.683-7.492-1.821H27.6c-6.958.002-12.598 5.872-12.6 13.114v3.279C15 48.554 17.35 51 20.25 51h31.5c2.9 0 5.25-2.446 5.25-5.464v-3.279c-.002-7.242-5.642-13.112-12.6-13.114zM36 25.5c6.765 0 12.25-5.708 12.25-12.75S42.765 0 36 0 23.75 5.708 23.75 12.75c-.002 3.382 1.288 6.626 3.586 9.018 2.298 2.391 5.415 3.734 8.664 3.732z",
    transform: "translate(-969 -452) translate(892 398) translate(32 54) translate(45) translate(0 9)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.5cb0f69c.svg";
export { ForwardRef as ReactComponent };